module.exports = __webpack_public_path__ + "static/media/i53.e15d6601.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i53.svg
// module id = 209
// module chunks = 8